import _ from 'lodash'
import backend from '../../components/utils/backend'

export default {
  state: {
    bookmarks: [],
    config: {}
  },
  mutations: {
    'SET_BOOKMARKS': function (state, bookmarks) {
      state.bookmarks = _.cloneDeep(bookmarks)
    },
    'SET_CONFIG': function (state, config) {
      state.config = _.cloneDeep(config)
    }
  },
  actions: {
    async deleteBookmark ({ rootGetters }, id) {
      try {
        await backend.delete(`/api/v1/sales-query-builder-bookmark/${id}`, rootGetters['session/accessToken'])
        return true
      } catch (error) {
        throw error
      }
    },
    async getBookmarks ({ rootGetters }, payload) {
      try {
        const { scope } = payload
        const bookmarks = (await backend.get(`/api/v1/sales-query-builder-bookmark?scope=${scope}`, rootGetters['session/accessToken'])).body
        return bookmarks
      } catch (error) {
        throw error
      }
    },
    async saveBookmark ({ rootGetters }, bookmark) {
      try {
        const response = (await backend.post('/api/v1/sales-query-builder-bookmark', rootGetters['session/accessToken'], bookmark)).body
        if (response.httpCode && response.httpCode === '500') {
          throw new Error(response)
        } else {
          return response
        }
      } catch (error) {
        throw error
      }
    },
    async getSalesQueryBuilderConfig ({ commit, getters, rootGetters }) {
      try {
        if (getters.config.length) {
          const config = (await backend.get('/api/v1/sales-query-builder-config', rootGetters['session/accessToken'])).body
          commit('SET_CONFIG', config)
          return getters.salesQueryBuilderConfig
        } else {
          return getters.salesQueryBuilderConfig
        }
      } catch (error) {
        throw error
      }
    }
  },
  getters: {
    config: state => state.config
  },
  namespaced: true
}
